import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { AdminMicrosite } from '@root/types';
import { ContentBlockWrapper, ContentBlockProps } from '..';
import { isSinglePageLayout, useMicrositeFormContext } from '../../utils';
import ColorPicker from '../../ColorPicker';
import TextColorSelector from '../../TextColorSelector';

export default function Gallery({ id, index, anchorSlug }: ContentBlockProps) {
  const { colorGroups, changeFontColorWithColorChange, sendPreviewTo } = useMicrositeFormContext();
  const flags = useFlags();
  const { t } = useTranslation('admin');
  const { values } = useFormikContext<Partial<AdminMicrosite>>();

  return (
    <ContentBlockWrapper
      contentBlockId={id}
      index={index}
      title={t('microsite.sections.gallery')}
      section="gallery"
      onClick={() =>
        sendPreviewTo({
          page: isSinglePageLayout(values.layout!) ? 'home' : 'gallery',
          element: isSinglePageLayout(values.layout!) ? anchorSlug : '',
        })
      }
    >
      <ColorPicker
        colorGroups={colorGroups}
        name="galleryBackgroundColor"
        labelText={t('microsite.backgroundColor')}
        onChange={changeFontColorWithColorChange('galleryTextColor')}
      />
      {flags['market-office.text-color-selector'] && <TextColorSelector name="galleryTextColor" />}
    </ContentBlockWrapper>
  );
}
